import type { MailSenderSubjectLayout } from '@email/shared';

export type ResolvedSenderSubjectLayout = 'horizontal' | 'stacked';

/** Resolve the synchronized preference without storing a device-specific result. */
export function resolveSenderSubjectLayout(
  preference: MailSenderSubjectLayout,
  phoneMode: boolean,
): ResolvedSenderSubjectLayout {
  if (preference === 'auto') return phoneMode ? 'stacked' : 'horizontal';
  return preference;
}
